export const COLLECTIONS = [
  {
    key: "archive", to: "/the-archive", label: "the archive",
    desc: "Piezas únicas de diseño autoral. Cada creación pertenece a una edición irrepetible y no vuelve a reproducirse. Una pieza, una sola vez.",
  },
  {
    key: "essentials", to: "/the-essentials", label: "the essentials",
    desc: "Piezas esenciales para construir, combinar y transformar. Diseños versátiles que conservan la identidad estética de ARCHIVE LAB.",
  },
  {
    key: "made_to_order", to: "/made-to-order", label: "made to order",
    desc: "Piezas disponibles por encargo. Cada pedido se confirma individualmente y se solicita especialmente para su nueva dueña.",
  },
];

export const collectionLabel = (key) => (COLLECTIONS.find((c) => c.key === key) || {}).label || "";
export const collectionMeta = (key) => COLLECTIONS.find((c) => c.key === key) || null;

export const GALLERY_DEFAULTS = ["/hero/foto2.webp", "/brand/img1.jpeg", "/hero/foto3.webp", "/hero/foto4.webp", "/brand/img2.jpeg", "/hero/foto5.webp"];
